/**
 * Events Calendar
 * Handles calendar widget loading and reformatting for custom display
 */

/**
 * Load MFN Calendar Widget
 * @param {string} widgetUrl - The MFN widget URL
 * @param {string} token - The calendar widget token
 * @param {string} locale - The locale/language code
 */
function loadMFNWidget(widgetUrl, token, locale) {
    // Initialize MFN loader if not already loaded
    if (!window._MF) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = widgetUrl + '/assets/js/loader-v5.js';
        document.body.appendChild(script);
    }
    
    window._MF = window._MF || {
        data: [],
        url: widgetUrl,
        ready: false,
        render: function() { window._MF.ready = true; },
        push: function(w) { window._MF.data.push(w); }
    };
    
    window._MF.push({
        query: "#calendar",
        widget: "calendar",
        locale: locale,
        token: token
    });
}

/**
 * Check if calendar has loaded and hide loading indicator
 * @param {string} loadingId - The loading indicator ID
 */
function checkCalendarLoaded(loadingId) {
    const table = document.getElementById('mf_calendar_table');
    const loadingIndicator = document.getElementById(loadingId);
    
    if (table) {
        const rows = table.querySelectorAll('tbody tr.mf_table-element');
        
        if (rows.length > 0) {
            // Calendar has loaded content
            if (loadingIndicator) {
                loadingIndicator.style.opacity = '0';
                setTimeout(() => {
                    loadingIndicator.style.display = 'none';
                }, 300);
            }
            return;
        }
    }
    
    // Keep checking
    setTimeout(() => checkCalendarLoaded(loadingId), 100);
}

/**
 * Reformat the calendar after it loads
 * @param {HTMLElement} calendarContainer - The calendar container element
 */
function reformatCalendar(calendarContainer) {
    const table = document.getElementById('mf_calendar_table');
    if (!table) {
        setTimeout(() => reformatCalendar(calendarContainer), 100);
        return;
    }

    const rows = table.querySelectorAll('tbody tr.mf_table-element');
    if (rows.length === 0) {
        setTimeout(() => reformatCalendar(calendarContainer), 100);
        return;
    }

    // Get title overwrites from data attribute
    const overwritesData = calendarContainer?.dataset?.titleOverwrites;
    let overwrites = [];
    
    if (overwritesData) {
        try {
            overwrites = JSON.parse(overwritesData);
        } catch (e) {
            console.error('Error parsing title overwrites:', e);
        }
    }

    // Get language from data attribute
    const lang = calendarContainer.dataset.lang || 'en';

    // Create custom grid container
    const gridContainer = document.createElement('div');
    gridContainer.id = 'mf_calendar_custom_grid';

    rows.forEach(row => {
        const dateCell = row.querySelector('.event_date');
        const contentCell = row.querySelector('td:nth-child(2)');
        
        if (!dateCell || !contentCell) return;

        // Parse date
        const dateStr = dateCell.textContent.trim();
        const date = new Date(dateStr);
        const day = date.getDate();
        const month = date.toLocaleDateString(lang, { month: 'short' }).replace('.', '');
        const year = date.getFullYear().toString().slice(-2);

        // Get event data
        const titleEl = contentCell.querySelector('.event_title');
        const linksEl = contentCell.querySelector('.event_links');
        let title = titleEl ? titleEl.textContent.trim() : '';

        // Check if there's a title overwrite for this date
        const dateFormatted = date.toISOString().split('T')[0]; // YYYY-MM-DD format
        const overwrite = overwrites.find(ow => ow.date === dateFormatted);
        if (overwrite && overwrite.title) {
            title = overwrite.title;
        }

        // Create card
        const card = document.createElement('div');
        card.className = 'mf_event_card';
        
        // Build calendar links dropdown
        let linksHtml = '';
        if (linksEl) {
            const links = linksEl.querySelectorAll('a');
            if (links.length > 0) {
                linksHtml = '<div class="mf_event_links_content">';
                links.forEach(link => {
                    linksHtml += `<a href="${link.href}" target="_blank">${link.textContent}</a>`;
                });
                linksHtml += '</div>';
            }
        }

        card.innerHTML = `
            <div class="mf_event_header">
                <time class="mf_event_date_display">
                    <span class="mf_event_day">${day}</span>
                    <span class="mf_event_month_year">${month}${lang == 'en' ? ',' : ''} ${year}</span>
                </time>
                <div class="mf_event_links_dropdown">
                    <button class="mf_event_add_button" type="button">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10 6V14" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6 10H14" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        ${dictionary.addToCalendar}
                    </button>
                    ${linksHtml}
                </div>
            </div>
            <h3 class="mf_event_title_styled">${title}</h3>
        `;

        gridContainer.appendChild(card);
    });

    // Insert grid before the table
    table.parentNode.insertBefore(gridContainer, table);
}

/**
 * Observe filter button clicks and re-reformat the grid
 */
function observeFilterButtons() {
    const futureBtn = document.getElementById('mf_filter_future');
    const pastBtn = document.getElementById('mf_filter_past');
    
    if (!futureBtn || !pastBtn) {
        setTimeout(observeFilterButtons, 100);
        return;
    }

    // Add custom click handlers to reformat after filter change
    [futureBtn, pastBtn].forEach(btn => {
        const originalOnClick = btn.onclick;
        btn.onclick = function() {
            if (originalOnClick) {
                originalOnClick.call(this);
            }
            // Wait for MFN to filter the table, then reformat
            setTimeout(() => {
                const calendarContainer = document.getElementById('calendar');
                if (calendarContainer) {
                    // Remove old custom grid
                    const oldGrid = document.getElementById('mf_calendar_custom_grid');
                    if (oldGrid) {
                        oldGrid.remove();
                    }
                    // Recreate the grid
                    reformatCalendar(calendarContainer);
                }
            }, 100);
        };
    });
}

/**
 * Initialize Events Calendar
 * Widget loading and loading indicator are handled by widget.js
 */
export function initEventsCalendar() {
    const calendarContainer = document.getElementById('calendar');
    if (!calendarContainer) return;

    // Wait for calendar to load and then restructure it
    reformatCalendar(calendarContainer);
    
    // Set up filter button observers
    observeFilterButtons();
}
